import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-positions',
  templateUrl: './positions.component.html',
  styleUrls: ['./positions.component.css']
})
export class PositionsComponent implements OnInit {
    argType;

    argValue;

    public searchText: string = '';

    public setting?: Setting;

    public itemsListPositions: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(1109, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadPositions() {
        if (!this.setting) return;

        return this.itemsListPositions = await this.datatask.Post(1110, {
            argtype: this.setting.argtype,
            argvalue: this.setting.argvalue
        });
    }

    private async init() {
        await this.loadSetting();
        this.loadPositions();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
    argtype: string;
    argvalue: string;
}
